<!--<div class="notification-message-container m-0 ">
<strong>Note:</strong> Please review the details of the transmission below. You can
<a (click)="downloadErrorReport()">download an error report (.xlsx)</a>
and <a (click)="downloadDAC6Report()">download the DAC6 Report (.xml)</a> for further review.
Once the issues have been resolved. You can choose to re-transmit via the options on this screen.
</div>-->

<table>
<!--
<tr>
  <th>Case ID</th>
  <th>{{item?.CaseId?.displayText}}</th>
</tr>
<tr class="first-row">
  <td>Reporting Entity</td>
  <th>{{item?.ReportingEntity?.displayText}}</th>
</tr>
<tr>
  <td>Reporting Country</td>
  <th>{{item?.ReportingCountry?.displayText}}</th>
</tr>
-->
  <!--<tr>
    <td>Status</td>
    <th>{{item?.Status?.displayText}}</th>
  </tr>-->
  <!--<tr>
    <td>Status Updated</td>
    <td>
      &lt;!&ndash;<div>12th July, 2020 at <span class="text-uppercase">00.00.00 UTC</span></div>&ndash;&gt;
      <div>{{item.modifiedDate|date:"medium": 'UTC'}}</div>
    </td>
  </tr>-->
  <!--<tr class="last-row">
    <td>Status Details</td>
    &lt;!&ndash;<td> Here we will display further information on why the status was given by the authority.</td>&ndash;&gt;
    <td>{{detailsDescription}}</td>
  </tr>-->

  <tr *ngFor="let elem of item?.Details?.value" [ngClass]="{'last-row': elem === item?.Details?.value.slice(-1)[0]}">
    <td>{{elem.header}}</td>
    <td>{{elem.value}}</td>
  </tr>
</table>


<!--<mat-form-field class="radio-box-input w-p-100 m-t-20" floatPlaceholder="always" floatLabel="always"
                appearance="outline">
  <mat-label>Select Action *</mat-label>
  <input matInput placeholder="Input" style="display: none"
         particleAnalytics
         analyticsCategory="radio-box-input-editor"
         analyticsAction="radio-box-input">
  <mat-radio-group class="dac6-case-hashtag-radio-group">
    <mat-radio-button class="dac6-case-hashtag-radio-button" [value]="'new'" fxLayout="column">
      Open and amend this Case in DAC6 Reporter for re-transmission
    </mat-radio-button>
    <mat-radio-button class="dac6-case-hashtag-radio-button" [value]="'existing'" fxLayout="column">
      Upload an amended version of this ML report for re-transmission
    </mat-radio-button>
    <mat-radio-button class="dac6-case-hashtag-radio-button" [value]="'existing2'" fxLayout="column">
      Re-transmit this XML report without any amendments
    </mat-radio-button>
  </mat-radio-group>

</mat-form-field>-->


